module.exports = __webpack_public_path__ + "static/media/avatar.34192e46.jpg";